import { Card, CardContent, CardHeader } from "@/components/ui/card";

export function CampaignConfigurationSection({
  title,
  children,
}: {
  title: string;
  children: React.ReactNode;
}) {
  return (
    <Card
      className="gap-0 overflow-hidden rounded-md py-0 shadow-none"
      data-slot="campaign-configuration-section"
    >
      <CardHeader className="border-b border-line px-6 py-3">
        <h2 className="font-heading text-lg font-semibold leading-snug">{title}</h2>
      </CardHeader>
      <CardContent className="p-0">{children}</CardContent>
    </Card>
  );
}
